module.exports = __webpack_public_path__ + "media/images/electrician-service-img-2-71439aa7f715161cfb21261e448e2c6d.jpg";